'use client'

import { useEffect, useRef, useState } from 'react'

import { useAbTest, useTrackAbTest } from '@marketplace-web/feature-flags/ab-tests-data'
import { useCookie, cookiesDataByName } from '@marketplace-web/environment/cookies-util'

import useShowHomeTabs from '../hooks/useShowHomeTabs'

const SCROLL_DOWN_THRESHOLD = 10
const SCROLL_UP_THRESHOLD = 5
const SHOW_AT_TOP_THRESHOLD = 150

const useHideTabs = () => {
  const [isHidden, setIsHidden] = useState(false)
  const lastScrollY = useRef(0)

  const abTest = useAbTest('homepage_hide_chips_on_scroll')
  const areTabsShown = useShowHomeTabs()
  const cookies = useCookie()
  const isBannerDismissed =
    cookies.get(cookiesDataByName.is_shipping_fees_applied_info_banner_dismissed) === 'true'

  const shouldExpose = areTabsShown && isBannerDismissed
  const isEnabled = abTest?.variant === 'on' && shouldExpose

  useTrackAbTest(abTest, shouldExpose)

  useEffect(() => {
    if (!isEnabled) return undefined

    const handleScroll = () => {
      const currentScrollY = window.scrollY

      if (currentScrollY < SHOW_AT_TOP_THRESHOLD) {
        setIsHidden(false)
        lastScrollY.current = currentScrollY
      } else if (currentScrollY > lastScrollY.current + SCROLL_DOWN_THRESHOLD) {
        setIsHidden(true)
        lastScrollY.current = currentScrollY
      } else if (currentScrollY < lastScrollY.current - SCROLL_UP_THRESHOLD) {
        setIsHidden(false)
        lastScrollY.current = currentScrollY
      }
    }

    window.addEventListener('scroll', handleScroll, { passive: true })

    return () => window.removeEventListener('scroll', handleScroll)
  }, [isEnabled])

  if (!isEnabled) return false

  return isHidden
}

export default useHideTabs
